import useClerkMetadata from "features/User/hooks/useClerkMetadata";

function useIncognitoMode() {
  const { userMetadata, updateUserMetadata } = useClerkMetadata();

  const isIncognitoModeActive = Boolean(userMetadata?.is_incognito_mode_active);

  const toggleIncognitoMode = async () => {
    updateUserMetadata({
      is_incognito_mode_active: !isIncognitoModeActive,
    });
  };

  return {
    isIncognitoModeActive,
    toggleIncognitoMode,
  };
}

export default useIncognitoMode;
